import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class PutAwayApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PUT_AWAY);
  }

  completePutaway(putawayId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${putawayId}/complete/`,
      {},
    );
  }

  getPutawayGRNLines(putawayId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${putawayId}/grn-lines/`,
    );
  }

  exportPutaway(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new PutAwayApi();
